// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"upload-translation__wrapper--1Q08s","module_wrapper":"upload-translation__module_wrapper--3o1bN","moduleWrapper":"upload-translation__module_wrapper--3o1bN"};